import { settingsManager } from '../../shared/settings';
import { auth } from '../../auth';

export const getSubstrateResourceName = (): string | undefined => {
  const tenantRegionSubScope = auth.user?.rawClaims?.tenant_region_sub_scope as string;
  switch (tenantRegionSubScope) {
    case 'DOD':
      return settingsManager.get('substrateResourceNameDoD');
    case 'DODCON':
      return settingsManager.get('substrateResourceNameGCCH');
    default:
      return settingsManager.get('substrateResourceName');
  }
};
